import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import _ from 'lodash';
import {logout, onForbidden} from '../account/login';
import {getCurrentGroup} from "../account/role";
import {getLocationData} from '../common/location';

//- Actions
export const onSetStartAccreditationRequest = createAction('SET_START_ACCREDITATION_REQUEST');
export const setStartAccreditationRequest = (id) => (dispatch, getState) => {
    let index = getAccreditationIndexById(getState(), id);
    dispatch(onSetStartAccreditationRequest(index));
    dispatch(cleanProcessedStatus());
};
export const cleanStartAccreditationRequest = createAction('CLEAN_START_ACCREDITATION_REQUEST');
export const onSetNextAsStartAccreditationRequest = createAction('SET_NEXT_AS_START_ACCREDITATION_REQUEST');
export const setNextAsStartAccreditationRequestForProcessing = () => (dispatch, getState) => {
    let list = getPendingAccreditationRequestsData(getState());
    let currentPage = getCurrentPageForAccreditationRequestsList(getState());
    let groupId = getCurrentGroup(getState());


    if (!_.isNil(list) && list.length > 0) {
        let currentIndex = getCurrentAccreditationRequestIndex(getState());
        if (currentIndex < list.length - 1) {
            dispatch(onSetNextAsStartAccreditationRequest(currentIndex + 1));
            dispatch(getAccreditationRequestsForProcessing(groupId, currentPage));
        } else {
            let totalPages = getTotalPagesForAccreditationRequestsList(getState());
            if (currentPage < totalPages - 1) {
                dispatch(onSetNextAsStartAccreditationRequest(0));
                dispatch(getAccreditationRequestsForProcessing(groupId, currentPage + 1));
            } else {
                dispatch(cleanStartAccreditationRequest());
            }
        }
    }
};

export const cleanProcessedStatus = createAction('CLEAN_PROCESSED_STATUS');
export const incrementNumberOfProcessedAccreditationRequests = createAction('NUMBER_OF_PROCESSED_ACCREDITATION_REQUESTS_INCREMENT');

export const fetchGetAccreditationRequestsForValidationFailed = createAction('FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_FAILED');
export const fetchGetAccreditationRequestsForValidationSuccess = createAction('FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_SUCCESS');

export const getAccreditationRequestsForProcessing = (group, page) => (dispatch, getState) => {
    if (!_.isNil(group)) {
        let countryFilter = getPendingAccreditationRequestsCountryFilter(getState());
        let domainFilter = getPendingAccreditationRequestsDomainFilter(getState());
        dispatch(fetchGetAccreditationRequestsForValidation(group, countryFilter, domainFilter, page));
    }
};

export const fetchGetAccreditationRequestsForValidation = createAction(
    'FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION',
    (groupId, countryFilter, domainFilter, page) => Api.getPendingAccreditationRequests(groupId, countryFilter, domainFilter, page),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationRequestsForValidationSuccess,
        onFail: fetchGetAccreditationRequestsForValidationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onProcessAccreditationRequestSuccess = () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    let currentPage = getCurrentPageForAccreditationRequestsList(getState());
    let groupId = getCurrentGroup(getState());
    dispatch(getAccreditationRequestsForProcessing(groupId, currentPage));
    dispatch(incrementNumberOfProcessedAccreditationRequests());
};
export const onConfirmAccreditationRequest = createAction(
    'FETCH_CONFIRM_ACCREDITATION_REQUEST',
    (id, data) => Api.confirmAccreditationRequest(id, data),
    () => ({
        apiCall: true,
        onSuccess: onProcessAccreditationRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchConfirmAccreditationRequest = (id, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onConfirmAccreditationRequest(id, data));
};

export const fetchRejectAccreditationRequest = createAction(
    'FETCH_REMOVE_ACCREDITATION',
    (id) => Api.rejectAccreditationRequest(id),
    () => ({
        apiCall: true,
        onSuccess: onProcessAccreditationRequestSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetAccreditationRequestsPerCountryForValidationFailed = createAction('FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_FAILED');
export const fetchGetAccreditationRequestsPerCountryForValidationSuccess = createAction('FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_SUCCESS');
export const fetchGetAccreditationRequestsPerCountryForValidation = createAction(
    'FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION',
    (groupId) => Api.getStaticsticsForPendingAccreditationRequests(groupId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationRequestsPerCountryForValidationSuccess,
        onFail: fetchGetAccreditationRequestsPerCountryForValidationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setAccreditationRequestsForValidationCountryFilter = createAction('SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER');
export const clearAccreditationRequestsForValidationCountryFilter = createAction('CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER');
export const onUpdateAccreditationRequestsForValidationCountryFilter = (countryFilter) => (dispatch, getState) => {
    dispatch(setAccreditationRequestsForValidationCountryFilter(countryFilter))
    let groupId = getCurrentGroup(getState());
    dispatch(fetchGetAccreditationRequestsForValidation(groupId, countryFilter));
    dispatch(fetchGetAccreditationRequestsPerDomainForValidation(groupId, countryFilter));
    dispatch(clearAccreditationRequestsForValidationDomainFilter());
}

export const onFetchGetAccreditationRequestsPerDomainForValidation = (groupId) => (dispatch, getState) => {
    let countryFilter = getPendingAccreditationRequestsCountryFilter(getState());
    dispatch(fetchGetAccreditationRequestsPerDomainForValidation(groupId, countryFilter));
}

export const fetchGetAccreditationRequestsPerDomainForValidationFailed = createAction('FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_FAILED');
export const fetchGetAccreditationRequestsPerDomainForValidationSuccess = createAction('FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_SUCCESS');
export const fetchGetAccreditationRequestsPerDomainForValidation = createAction(
    'FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION',
    (groupId, countryCode) => Api.getStaticsticsForPendingAccreditationRequests(groupId, countryCode, 'DOMAIN'),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationRequestsPerDomainForValidationSuccess,
        onFail: fetchGetAccreditationRequestsPerDomainForValidationFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
)

export const setAccreditationRequestsForValidationDomainFilter = createAction('SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER');
export const clearAccreditationRequestsForValidationDomainFilter = createAction('CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER');
export const onUpdateAccreditationRequestsForValidationDomainFilter = (domain) => (dispatch, getState) => {
    dispatch(setAccreditationRequestsForValidationDomainFilter(domain));
    let groupId = getCurrentGroup(getState());
    let countryFilter = getPendingAccreditationRequestsCountryFilter(getState());
    dispatch(fetchGetAccreditationRequestsForValidation(groupId, countryFilter, domain));
}

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
    currentAccreditationRequestIndex: null,
    processed: 0,
    currentPage: null,
    totalPages: null,
    leftNumber: null,
    requestsPerCountry: null,
    fetchingRequestsPerCountry: false,
    requestsPerDomain: null,
    fetchingRequestsPerDomain: false,
    countryFilter: null,
    domainFilter: null,
};

//- Reducers
export default handleActions({

    FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION: (state) => {
        return {
            ...state,
            data: null,
            currentPage: null,
            totalPages: null,
            leftNumber: null,
            error: null,
            fetching: true
        };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_FAILED: (state, action) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ACCREDITATION_REQUESTS_FOR_VALIDATION_SUCCESS: (state, action) => {
        return {
            ...state,
            data: action.payload.content,
            currentPage: action.payload.number,
            totalPages: action.payload.totalPages,
            leftNumber: action.payload.totalElements,
            error: null,
            fetching: false
        };
    },
    SET_START_ACCREDITATION_REQUEST: (state, action) => {
        return {...state, currentAccreditationRequestIndex: action.payload}
    },
    SET_NEXT_AS_START_ACCREDITATION_REQUEST: (state, action) => {
        return {...state, currentAccreditationRequestIndex: action.payload}
    },
    CLEAN_PROCESSED_STATUS: (state) => {
        return {...state, processed: 0}
    },
    CLEAN_START_ACCREDITATION_REQUEST: (state) => {
        return {...state, currentAccreditationRequestIndex: null}
    },
    NUMBER_OF_PROCESSED_ACCREDITATION_REQUESTS_INCREMENT: (state) => {
        return {...state, processed: state.processed + 1}
    },
    ACCREDITATION_GROUP_LIST_RESET: (state) => {
        return {...state, data: null}
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION: (state) => {
        return { ...state, requestsPerCountry: null, error: null, fetchingRequestsPerCountry: true };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_FAILED: (state, action) => {
        return { ...state, requestsPerCountry: null, error: action.payload, fetchingRequestsPerCountry: false };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_COUNTRY_FOR_VALIDATION_SUCCESS: (state, action) => {
        return { ...state, requestsPerCountry: action.payload, error: null, fetchingRequestsPerCountry: false };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION: (state) => {
        return { ...state, requestsPerDomain: null, error: null, fetchingRequestsPerDomain: true };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_FAILED: (state, action) => {
        return { ...state, requestsPerDomain: null, error: action.payload, fetchingRequestsPerDomain: false };
    },
    FETCH_GET_ACCREDITATION_REQUESTS_PER_DOMAIN_FOR_VALIDATION_SUCCESS: (state, action) => {
        return { ...state, requestsPerDomain: action.payload, error: null, fetchingRequestsPerDomain: false };

    },
    SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER: (state, action) => {
        return {...state, countryFilter: action.payload}
    },
    SET_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER: (state, action) => {
        return {...state, domainFilter: action.payload}
    },
    CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_COUNTRY_FILTER: (state) => {
        return {...state, countryFilter: null}
    },
    CLEAR_ACCREDITATION_REQUESTS_FOR_VALIDATION_DOMAIN_FILTER: (state) => {
        return {...state, domainFilter: null}
    },

}, initialState);

//- Selectors
export const getPendingAccreditationRequests = state => state.pendingAccreditationRequests;

export const getPendingAccreditationRequestsData = state => getPendingAccreditationRequests(state).data;

export const getCurrentPageForAccreditationRequestsList = state => getPendingAccreditationRequests(state).currentPage;

export const getTotalPagesForAccreditationRequestsList = state => getPendingAccreditationRequests(state).totalPages;

export const getLeftAccreditationRequestsNumber = state => getPendingAccreditationRequests(state).leftNumber;

export const loadingPendingAccreditationRequestsList = state => getPendingAccreditationRequests(state).fetching;

export const getCurrentAccreditationRequestIndex = state => getPendingAccreditationRequests(state).currentAccreditationRequestIndex;

export const getNumberOfProcessedAccreditationRequests = state => getPendingAccreditationRequests(state).processed;

export const getAccreditationRequestDataByIndex = (state, index) => {
    let data = getPendingAccreditationRequestsData(state);
    if (_.isNil(data) || _.isNil(index) || index < 0 || index > (data.length - 1)) {
        return null;
    } else {
        return data[index];
    }
};

export const getCurrentAccreditationRequestId = state => {
    let index = getCurrentAccreditationRequestIndex(state);
    let data = getAccreditationRequestDataByIndex(state, index);
    if (!_.isNil(data)) {
        return data.id;
    }
};

export const getAccreditationIndexById = (state, id) => {
    let accreditationRequestsList = getPendingAccreditationRequestsData(state);

    if (_.isNil(accreditationRequestsList)) {
        return null;
    }

    let index = _.findIndex(accreditationRequestsList, (elem) => {
        return elem.id === id;
    });

    if (index < 0) {
        return null;
    } else {
        return index;
    }
};

export const getPendingAccreditationRequestsPerCountryData = state => getPendingAccreditationRequests(state).requestsPerCountry;

export const loadingPendingAccreditationRequestsPerCountryData = state => getPendingAccreditationRequests(state).fetchingRequestsPerCountry;

export const getPendingAccreditationRequestsPerDomainData = state => getPendingAccreditationRequests(state).requestsPerDomain;

export const loadingPendingAccreditationRequestsPerDomainData = state => getPendingAccreditationRequests(state).fetchingRequestsPerDomain;

export const getPendingAccreditationRequestsCountryFilter = state => getPendingAccreditationRequests(state).countryFilter;

export const getPendingAccreditationRequestsDomainFilter = state => getPendingAccreditationRequests(state).domainFilter;

export const getPendingAccreditationRequestsPerContinentData = state => {
    let countryData = getPendingAccreditationRequests(state).requestsPerCountry;
    if (_.isNil(countryData)) {
        return null;
    }

    let locationData = getLocationData(state);
    let continentData = _.mapValues(locationData, (value, key) => ({value: key, count: 0}));

    _.forEach(countryData, el => {
        let continent = _.findKey(locationData, countries => countries.includes(el.value));
        continentData[continent].count += el.count;
    });

    return _.values(continentData);
};


// WEBPACK FOOTER //
// ./src/reducers/accreditation/pendingAccreditationRequests.js